import React, { useEffect, useRef, useState } from 'react';
import Panel from 'Components/Panel/Panel';
import Button from 'Components/Button/Button';

const OptionsPanel = ({
    options = [],
    zIndex,
    selectDefault,
    defaultValue,
    mainPanelStyle,
    titleOptionsStyle,
    attributesToValidateSelectedOption,
    goPreviousTab,
    onSelectOption,
    styleOptionSelected,
    height = '100%'
}) => {
    const [selectedOption, setSelectedOption] = useState(0);

    // controla se usuário já interagiu (isso é o divisor de águas)
    const userControlledRef = useRef(false);

    // DEFAULT só roda UMA vez (ou quando explicitamente reativado)
    useEffect(() => {
        if (!options.length) return;

        if (selectDefault && !userControlledRef.current) {
            const initial =
                options[defaultValue] ? defaultValue : 0;

            setSelectedOption(initial);
            onSelectOption?.(initial);
        }
    }, [selectDefault, options]);

    // validação só corrige estado inválido (não escolhe novo estado)
    useEffect(() => {
        if (!options.length) return;

        if (options[selectedOption]) return;

        // se atual índice não existe, cai pra 0
        setSelectedOption(0);
        onSelectOption?.(0);
    }, [options]);

    function onUpdateSelectedOption(index, readOnly, option) {
        if (readOnly || !options[index]?.component) return;

        if (option.sequence || option.setSequenceClicked) {
            const ok = option.setSequenceClicked(option.sequence);
            if (!ok) return;
        }

        userControlledRef.current = true;

        setSelectedOption(index);
        onSelectOption?.(index);
    }

    const safeSelectedOption = options[selectedOption]
        ? selectedOption
        : 0;

    return (
        <Panel
            style={{
                width: '100%',
                height,
                flexDirection: 'column',
                zIndex,
                ...mainPanelStyle
            }}
        >
            <Panel
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    height: '30px',
                    ...titleOptionsStyle
                }}
            >
                {options.map((option, index) => (
                    <Button
                        key={index}
                        clickMethod={() =>
                            onUpdateSelectedOption(index, option.readOnly, option)
                        }
                        buttonName={option?.label}
                        style={{
                            fontWeight:
                                safeSelectedOption === index
                                    ? 'bold'
                                    : 'normal',
                            backgroundColor: '#f5f5f5',
                            color: option.colorCode || 'black',
                            borderRadius: '0px',
                            padding: '5px',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            ...(safeSelectedOption === index
                                ? styleOptionSelected
                                : {})
                        }}
                    />
                ))}
            </Panel>

            <Panel
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    height: 'calc(100% - 30px)'
                }}
            >
                {options?.[safeSelectedOption]?.component}
            </Panel>
        </Panel>
    );
};

export default OptionsPanel;